import { combineReducers } from 'redux';
import appReducer from 'layout/reducers';

const combineReducer = combineReducers({
  app: appReducer,
});

const rootReducer = (state, action) => combineReducer(state, action);

export default rootReducer;
